export const BREAKPOINTS = {
  xs: 420,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1400
};

export const BLOGS_PER_PAGE = 9;
export const COURSES_PER_PAGE = 9;

export const NEXT_LOCALE = 'lang';
export const SUGGESTED_LANGUAGE = 'SUGGESTED_LANGUAGE';

export const CUSTOM_EVENTS = {
  GLOSSARY_SEARCH: 'GLOSSARY_SEARCH'
};
